<template>
  <div class="inputFrom">
    <!-- <el-card shadow="hover"> -->
    <el-form :inline="true" ref="formSearch" class="formSearch" :model="form" :label-width="labelWidth" :label-position="labelPosition">
      <span v-for="(item, idx) in inputData" :key="idx" :class="!isDialog ? 'formSearch_span':''">
        <!-- 隐藏占位 -->
        <el-form-item v-if="item.seize" style="opacity: 0" class="seize">
          <div :style="item.width ? item.width : 'width:280px;'"></div>
        </el-form-item>

        <!-- 下拉选择框 -->
        <el-form-item v-else-if="item.selectArr" :label="item.name">
          <template v-if="defaultSelectArr">
            <el-select
              size="small"
              v-model="form[item.val]"
              :placeholder="item.placeholder ? item.placeholder : item.name"
              :style="item.width ? 'width:' + item.width + 'px' : 'width:280px;'"
            >
              <el-option v-for="(k, i) in item.selectArr" :label="k.label" :value="k.id" :key="i" :disabled="k.disabled"></el-option>
            </el-select>
          </template>
          <el-select
            v-else
            size="small"
            v-model="form[item.val]"
            :placeholder="item.placeholder ? item.placeholder : item.name"
            :style="item.width ? 'width:' + item.width + 'px' : 'width:280px;'"
          >
            <el-option v-for="(k, i) in item.selectArr" :label="k.label" :value="k.id" :key="i"></el-option>
          </el-select>
          <template v-if="item.children">
            <span style="margin: 15px"></span>
            <el-input
              size="small"
              v-model="form[item.children[0].val]"
              :placeholder="item.children[0].placeholder ? item.children[0].placeholder : ''"
              send_channel_shunt
              style="width: 125px"
            >
            </el-input>
          </template>
        </el-form-item>
        <!-- 级联选择器 -->
        <el-form-item v-else-if="item.cascaderArr" :label="item.name">
          <el-cascader
            :style="item.width ? 'width:' + item.width + 'px' : 'width:280px;'"
            :label="item.name"
            v-model="form[item.val]"
            :show-all-levels="false"
            collapse-tags
            :options="item.cascaderArr"
            :props="{
              multiple: item.multiple,
              expandTrigger: 'hover',
              emitPath: false,
            }"
          ></el-cascader>
        </el-form-item>
        <!-- 单选框 -->
        <el-form-item v-else-if="item.radioArr" :label="item.name">
          <el-radio-group size="small" v-model="form[item.val]" @change="redioActive">
            <template v-for="(k, i) in item.radioArr">
              <el-radio v-if="k.children" :label="k.label" :key="i"
                >{{ k.val }}
                <!-- 内嵌日期选择组件 -->
                <span>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="form[k.children[0].val[0]]"
                    type="datetime"
                    :placeholder="item.startPlaceholder || '选择日期时间'"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 126px; display: inline-block; font-size: 12px"
                    class="time1"
                    :disabled="dis"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <span class="time_to_text" style="color: #666666"> 至 </span>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="form[k.children[0].val[1]]"
                    type="datetime"
                    :disabled="dis"
                    :placeholder="item.endPlaceholder || '选择日期时间'"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 145px; display: inline-block; font-size: 12px"
                    class="time2"
                    :clearable="false"
                  >
                  </el-date-picker>
                </span>
              </el-radio>
              <el-radio v-else :label="k.label" :key="i">{{ k.val }}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>

        <!-- 双下拉选择框，联动 -->
        <el-form-item v-else-if="item.selectArrDouble" :label="item.name">
          <div style="width: 280px">
            <el-select
              size="small"
              v-model="form[item.selectArrDouble[0].val]"
              :placeholder="item.selectArrDouble[0].placeholder ? item.selectArrDouble[0].placeholder : item.selectArrDouble[0].name"
              style="width: 116px; margin-right: 8px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option v-for="(k, i) in item.selectArrDouble[0].selectArr" :label="k.label" :value="k.id" :key="i"></el-option>
            </el-select>
            <el-select
              v-if="form[item.selectArrDouble[0].val] == item.showSelect2Id"
              size="small"
              v-model="form[item.selectArrDouble[1].val]"
              :placeholder="item.selectArrDouble[1].placeholder ? item.selectArrDouble[1].placeholder : item.selectArrDouble[1].name"
              style="width: 155px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option v-for="(k, i) in item.selectArrDouble[1].selectArr" :label="k.label" :value="k.id" :key="i"></el-option>
            </el-select>
          </div>
        </el-form-item>

        <!-- input、日期选择器 -->
        <el-form-item v-else :label="item.name">
          <!-- 时间插件 -->
          <el-date-picker
            v-if="item.dateVal"
            :default-time="item.defaultTime || ''"
            :type="item.type ? item.type : 'datetime'"
            :range-separator="item.range ? item.range : '至'"
            :value-format="item.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
            :placeholder="item.placeholder ? item.placeholder : ''"
            :start-placeholder="item.startPlaceholder ? item.startPlaceholder : '开始日期'"
            :end-placeholder="item.endPlaceholder ? item.endPlaceholder : '结束日期'"
            @input="immediUpdate"
            size="small"
            v-model="form[item.val]"
          >
          </el-date-picker>
          <div class="my_select_time" v-else-if="item.myDate">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="form[item.val[0]]"
              :type="item.type ? item.type : 'datetime'"
              :placeholder="item.startPlaceholder || '选择日期时间'"
              size="small"
              :format="item.format || 'yyyy-MM-dd HH:mm:ss'"
              :value-format="item.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
              :picker-options="pickerOptionsStart(item.val[1])"
              style="width: 126px; font-size: 12px"
              class="time1"
              :clearable="false"
            >
            </el-date-picker>
            <div class="time_to_text" style="color: #666666">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="form[item.val[1]]"
              :type="item.type ? item.type : 'datetime'"
              :placeholder="item.endPlaceholder || '选择日期时间'"
              size="small"
              :format="item.format || 'yyyy-MM-dd HH:mm:ss'"
              :value-format="item.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
              :picker-options="pickerOptionsEnd(item.val[0])"
              style="width: 140px; font-size: 12px"
              class="time2"
              :clearable="false"
              :default-time="'23:59:59'"
            >
            </el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTime(item.val[0], item.val[1])"></i>
            <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
          </div>
          <template v-else-if="item.isNumber">
            <el-input
              send_channel_shunt
              oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
              :style="item.width ? 'width:' + item.width + 'px' : 'width:280px;'"
              v-model="form[item.val]"
              :maxlength="item.maxlength"
              :placeholder="item.placeholder"
            >
            </el-input>
          </template>
          <template v-else-if="item.isNumberN">
            <el-input
              send_channel_shunt
              @input="limitNumber(form[item.val], item.val)"
              :style="item.width ? 'width:' + item.width + 'px' : 'width:280px;'"
              v-model="form[item.val]"
              :maxlength="item.maxlength"
              :placeholder="item.placeholder"
            >
            </el-input>
          </template>
          <!-- input表单 -->
          <template v-else-if="item.iptArr">
            <span v-for="(data, index) in item.iptArr" :key="index">
              <span v-if="index > 0">&nbsp; 至 &nbsp;</span>
              <el-input
                size="small"
                send_channel_shunt
                style="width: 125px"
                oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                v-model="form[data.val]"
                :maxlength="data.maxlength"
                :placeholder="data.placeholder ? data.placeholder : data.name"
              >
              </el-input>
            </span>
          </template>

          <el-input
            v-else
            size="small"
            send_channel_shunt
            :style="item.width ? 'width:' + item.width + 'px' : 'width:280px;'"
            v-model="form[item.val]"
            :maxlength="item.maxlength"
            :placeholder="item.placeholder ? item.placeholder : item.name"
          >
          </el-input>
        </el-form-item>

        <!-- <el-form-item v-if="btnPosition && idx === inputData.length - 1">
          <div style="margin-left: 12px">
            <el-button size="small" class="search" v-zoom="{ from: pageName, name: '查询' }" @click="submitForm('formSearch', true)">
              查询
            </el-button>
            <el-button size="small" class="reset" @click="resetForm" v-if="reset != '1'">重置</el-button>
          </div>
        </el-form-item>

        <el-form-item v-if="btnPosition1 && idx === inputData.length - 1">
          <div style="margin-left: 120px">
            <el-button size="small" class="search" v-zoom="{ from: pageName, name: '查询' }" @click="submitForm('formSearch', true)">
              查询
            </el-button>
            <el-button size="small" class="reset" @click="resetForm" v-if="reset != '1'">重置</el-button>
          </div>
        </el-form-item>

        <el-form-item v-if="btnPosition2 && idx === inputData.length - 1">
          <div style="margin-left: 35px">
            <el-button size="small" class="search" v-zoom="{ from: pageName, name: '查询' }" @click="submitForm('formSearch', true)">
              查询
            </el-button>
            <el-button size="small" class="reset" @click="resetForm" v-if="reset != '1'">重置</el-button>
          </div>
        </el-form-item> -->
      </span>
      <span class="formSearch_span">
        <!-- 查询、重置按钮位置-->
        <el-form-item>
          <div style="margin-left:52px">
            <el-button size="small" class="search" @click="submitForm('formSearch', true)">
              查询
            </el-button>
            <el-button size="small" class="reset" @click="resetForm" v-if="reset != '1'">重置</el-button>
          </div>
        </el-form-item>
      </span>
    </el-form>
    <div class="el_btn" v-if="!btnPosition && !btnPosition1 && !btnPosition2">
      <el-button size="small" class="search" v-zoom="{ from: pageName, name: '查询' }" @click="submitForm('formSearch', true)">
        <!-- <i class="el-icon-search" style="display: inline-block; width: 14px; height: 12px"></i> -->
        查询
      </el-button>
      <el-button size="small" class="reset" @click="resetForm" v-if="reset != '1'">重置</el-button>
    </div>
    <!-- </el-card> -->
  </div>
</template>

<script>
export default {
  name: "inputForm",
  props: {
    // selectArr（下拉组件值），seize（占位）
    pageName: {
      type: String,
      default: "表单查询",
    },
    inputData: {
      type: Array,
    },
    defaultValue: {
      type: Array,
    },
    // defaultSelectArr下拉框 默认与禁用选择开启    inputData里面的selectArr下拉框字段里面第一个defaultValue为默认值，disabled为false可不传
    // [{
    //   name: "发放类型:",
    //   val: "grantType",
    //   placeholder: "请选择",
    //   selectArr: [
    //     { label: "促销绑定", id: 1, defaultValue: 3, disabled: true },
    //     { label: "免费领取", id: 3 },
    //   ],
    // }]
    defaultSelectArr: {
      type: Boolean,
      default: false,
    },
    btnPosition: {
      type: Boolean,
      default: false,
    },
    btnPosition1: {
      type: Boolean,
      default: false,
    },
    btnPosition2: {
      type: Boolean,
      default: false,
    },
    reset: {
      type: String,
    },
    labelPosition: {
      type: String,
      default: "right",
    },
    time: {
      type: Number, // 4.表示后台管理-短信账单列表, 商品评价分析 5.后台管理-短信账单弹窗都用到 6.商品评价分析-统计时间
    },
    limit30: {
      // 是否限制时间范围为30天（下单时间-手动崔评）
      type: Boolean,
      default: false,
    },
    one: {
      type: Number,
    },
    // 删除空字段
    deleteNull: {
      type: Boolean,
      default: false,
    },
    // 是否弹窗引用
    isDialog:{
      type: Boolean,
      default: false,
    },
    labelWidth:{
      default:'120px'
    }
  },

  data() {
    return {
      form: {
        current: 1,
        size: 20,
      },
      totalCount: 0,
      minTime: "",
      list: [],
      dis: true,
      mytimestart: "",
      mytimeend: "",
    };
  },
  // computed:{
  //   seachWidth(){
  //     let num = this.inputData.length

  //   }
  // },
  watch: {
    immediate: true,
    one: {
      handler(newName, oldName) {
        // console.log(newName, oldName);
      },
    },
  },
  created() {},
  mounted() {
    this.initVal();
    // 下拉框默认
    // console.log(this.inputData, 11111);

    // console.log('this.form=========:', this.form)
    if (this.time == 1) {
      this.form.orderStartTimeStart = this.getDateStr(-30) + " 00:00:00";
      this.form.orderStartTimeEnd = this.getDateStr(0) + " 23:59:59";
    }
    if (this.limit30) {
      this.minTime = new Date(this.getDateStr(-30) + " 00:00:00").getTime();
    }
    if (this.time == 2) {
      this.form.creationTimeStart = this.getDateStr(-29) + " 00:00:00";
      this.form.creationTimeEnd = this.getDateStr(1) + " 00:00:00";
    }
    if (this.time == 4) {
      this.form.startTime = this.getDateStr(-31);
      this.form.endTime = this.getDateStr(-1);
    }
    if (this.time == 5) {
      this.form.startTime = this.defaultValue[0];
      this.form.endTime = this.defaultValue[1];
    }
    if (this.time == 6) {
      this.form.startTime = this.getDateStr(-30) + " 00:00:00";
      this.form.endTime = this.getDateStr(0) + " 23:59:59";

      this.minTime = new Date(this.getDateStr(-90) + " 00:00:00").getTime();
    }
    // var time2 = new Date().Format("yyyy-MM-dd hh:mm:ss");
    // console.log(this.one)
  },
  methods: {
    limitNumber(val, key) {
      this.form[key] = val.replace(/^\.+|[^\d]/g, "");
      // console.log(this.form[key])
    },
    initVal() {
      // 表单初始值处理
      let inputData = this.inputData;
      for (let item of inputData) {
        if (item.children) {
          let childItem = item.children[0];
          this.$set(this.form, childItem.val, "");
        }
        if (item.radioArr) {
          for (let items of item.radioArr) {
            if (items.children) {
              if (items.children[0].myDate) {
                let childItem = items.children[0];
                this.$set(this.form, childItem.val[0], "");
                this.$set(this.form, childItem.val[1], "");
              }
            }
          }
        }
        if (item.iptArr) {
          if (Array.isArray(item.iptArr)) {
            for (let i of item.iptArr) {
              this.$set(this.form, i.val, null);
            }
          }
        } else {
          let key = item["val"];
          if (typeof item["initVal"] != "undefined") {
            let val = item["initVal"];
            this.$set(this.form, key, val);
          } else if (typeof key != "undefined") {
            if (item.default) {
              this.$set(this.form, key, item.default);
            } else {
              this.$set(this.form, key, "");
            }
          }

          if (item.myDate && !item.noInitValue) {
            if (Array.isArray(key)) {
              this.$set(this.form, key[0], null);
              this.$set(this.form, key[1], null);
              delete this.form[key];
              if (item.isdefault) {
                let yy = new Date().getFullYear(); //当前年份
                let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
                let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate(); //当前天数
                this.mytimestart = `${yy}-${mm}-${dd} 00:00:00`;
                this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
                // console.log(this.getDateStr(-30), this.mytimeend);
                this.$set(this.form, key[0], this.getDateStr(-30) + " 00:00:00");
                this.$set(this.form, key[1], this.mytimeend.toString());
                delete this.form[key];
              }
            }
          }
        }
      }
      // 下拉框禁用
      if (this.defaultSelectArr) {
        this.inputData.forEach((item) => {
          if (item.selectArr) {
            this.form[item.val] = item.selectArr[0].defaultValue;
          }
        });
      }
    },
    submitForm(formName, state) {
      // console.log("this.form:", this.form);
      //查询表单前端验证
      let self = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.bus.$emit("pageto", this.form);
          this.form.current = 1;
          self[formName](state);
        } else {
          return false;
        }
      });
    },
    formSearch(str) {
      //搜索
      // console.log(this.deleteNull);

      if (this.deleteNull) {
        let params = JSON.parse(JSON.stringify(this.form));
        for (var i in params) {
          if (params[i] + "" == "") {
            delete params[i];
          }
        }
        this.$emit("toParentVal", params, str);
      } else {
        this.$emit("toParentVal", this.form, str);
      }
    },
    // 导出
    export_fun() {
      if (this.deleteNull) {
        let params = JSON.parse(JSON.stringify(this.form));
        for (var i in params) {
          if (params[i] + "" == "") {
            delete params[i];
          }
        }
        console.log("export_get", params);
        this.$emit("export_get", params);
      } else {
        console.log("export_get", this.form);
        this.$emit("export_get", this.form);
      }
    },
    export_fun2(){
      let params = JSON.parse(JSON.stringify(this.form));
      console.log(params,22222222222222)
      return params
    },

    resetForm() {
      // 重置
      for (let k in this.form) {
        this.form[k] = "";
      }
      this.form = {
        current: 1,
        size: 20,
      };
      this.initVal();
      this.formSearch("reset");
    },
    immediUpdate(e) {
      // if (!e) {
      //     delete this.form.creatTimeEnd
      //     delete this.form.creatTimeStart
      // }
    },
    pickerOptionsStart(field) {
      return {
        disabledDate: (time) => {
          if (this.form[field]) {
            var flag = false;
            if (this.limit30 || this.time == "6") {
              flag = time.getTime() > new Date(this.form[field]).getTime() || time.getTime() < this.minTime;
            } else {
              flag = time.getTime() > new Date(this.form[field]).getTime();
            }
            return flag;
          }
        },
      };
    },
    pickerOptionsEnd(field) {
      return {
        disabledDate: (time) => {
          var flag = false;
          if (this.time == "4" || this.time == "5") {
            if (time > Date.now() - 8.64e7) {
              flag = true;
            }
          }
          if (this.time == "6") {
            if (time > Date.now()) {
              flag = true;
            }
          }

          if (this.form[field]) {
            return time.getTime() < new Date(this.form[field]).getTime() || flag;
          }
        },
      };
    },
    clearTime(a, b) {
      this.form[a] = null;
      this.form[b] = null;
    },
    // 单选框change事件，赶时间先写死了
    redioActive(val) {
      // 单选框label选择到custom，解锁dete组件
      if (val === "custom") {
        this.dis = false;
      } else {
        this.dis = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.formSearch {
  display: flex;
  flex-wrap: wrap;
  min-width: 894px;
}
.formSearch_span {
  width: 33.3%;
}
@media screen and (max-width: 1558px) {
  .formSearch_span {
    width: 50%;
  }
}
@media screen and (max-width: 1145px) {
  .formSearch_span {
    width: 70%;
  }
}
// /deep/.my_select_time .el-input__inner{
//     padding: 0px 8px!important;
// }
.inputFrom {
  .el_btn {
    text-align: center;
  }
  /deep/.my_select_time {
    display: flex;
    align-items: center;
  }
  .search,
  .reset {
    width: 98px !important;
    font-size: 14px;
    height: 32px !important;
    transition: all 0.2s;
  }
  .search {
    color: #fff;
    border: 1px solid #2670fb;
    background-color: #2670fb;
    &:hover {
      opacity: 0.8;
    }
  }
  .reset {
    color: #666666;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #2670fb;
      border: 1px solid #2670fb;
      background: rgba(38, 112, 251, 0.1);
    }
  }
  @media screen and (max-width: 1720px) {
    .seize {
      display: none;
    }
  }
}
</style>
<style lang="scss">
/deep/ .el-cascader__dropdown {
  z-index: 3333 !important;
}
.inputFrom {
  .el-card__body {
    padding: 20px;
  }
  .el-range-editor.el-input__inner {
    padding: 3px 6px;
  }
  .el-date-editor .el-range-separator {
    padding: 0;
  }
  .el-date-editor {
    display: flex;
    justify-content: space-between;
    .el-range-input {
      width: 24%;
      overflow: hidden;
    }
  }
  .el-form-item__label {
    white-space: nowrap;
  }
}
</style>
